import { withStyles } from '@material-ui/core/styles';
import React from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Fade,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { format, parse } from 'date-fns';
import BeneficiarioApi from '../../api/BeneficiarioApi.js';
import GuiaApi from '../../api/GuiaApi.js';
import TipoAtendimentoApi from '../../api/TipoAtendimentoApi.js';
import { withAuditoria } from '../../contexts/AuditoriaContext.jsx';
import { withLoading } from '../../contexts/LoadingContext.jsx';
import { withSnackbar } from '../../contexts/SnackbarContext.jsx';

import ButtonAlertas from './ButtonAlertas.jsx';
import ButtonAnexos from './ButtonAnexos.jsx';
import ButtonGlosas from './ButtonGlosas.jsx';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import OpenInNew from '@material-ui/icons/OpenInNew';
import ButtonHistoricoGuia from './ButtonHistoricoGuia.jsx';
import MenuListGuia from './MenuListGuia.jsx';
import Utils from './Utils.js';

import { LinearProgress } from '@material-ui/core';
import CarenciaApi from '../../api/CarenciaApi.js';
import ElementoApi from '../../api/ElementoApi.js';
import LinearProgressBlockScreen from './LinearProgressBlockScreen.jsx';
import PainelElementos from './PainelElementos.jsx';


const styles = theme => ({
  guiaContainer: {
    display: 'block',
    overflow: 'auto',
    flexGrow: 1,
    paddingBottom: theme.spacing(4),
    marginBottom: theme.spacing(1)
  },
  root: {
    backgroundColor: '#F5EBFF',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(1)
  },
  iconParecer: {
    fontSize: 14,
    marginRight: theme.spacing(1),
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: 11,
  },
  labelDadosInternacao: {
    color: theme.palette.text.secondary,
    fontSize: 11,
    marginTop: theme.spacing(1),
  },
  labelDetalhe: {
    fontSize: 11,
    fontWeight: 'bold'
  },
  labelMotivoRecurso: {
    // display: 'inline',
    color: theme.palette.secondary.main,
    // marginTop: theme.spacing(4),
    fontSize: 11,
  },
  labelDetalheParecer: {
    fontSize: 11,
    fontWeight: 'bold',
    maxWidth: theme.spacing(40),
  },
  selectTipoAtendimento: {
    marginTop: theme.spacing(-2.8),
  },
  buttonParecer: {
    color: theme.palette.text.secondary,
    fontSize: 11,
    marginTop: theme.spacing(-1),
  },
  gridItemGuia: {
    marginRight: theme.spacing(0),
    minWidth: theme.spacing(32),
    maxWidth: theme.spacing(32),
  },
  gridItemGuiaLarge: {
    marginRight: theme.spacing(0),
    minWidth: theme.spacing(64),
    maxWidth: theme.spacing(64),
  }
});

class Guia extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      guia: this.props.guia,
      carencias: [],
      elementos: [],
      isElementosCarregado: false,
      openCarencias: false,
      guiaOriginal: {},
      guiasSolicitacao: [],
      operacao: {
        clickedButton: '',
        dialog: {
          open: false,
          title: '',
          message: '',
        },
      },
      openDialogGlosaGuia: false,
      dialogOpenErrosValidacao: false,
      dialogContent: [],
      dialogTitle: [],
      // expanded: false,
      anchorElVertMenu: null,
      snackOpen: false,
      guiasSolicitacaoOpen: false,
      openDialogHistorico: false,
      tituloFormDialog: '',
      tiposDeAtendimento: [],
      desTipoAtendimentoSelected: undefined,
      codTipoAtendimentoSelected: undefined,
      codTipoAtendimentoPrev: undefined,
      edicaoTipoAtendimento: false,

      caraterSolicitacao: [],
      codCaraterSolicitacaoSelected: undefined,
      desCaraterSolicitacaoSelected: undefined,
      codCaraterSolicitacaoPrev: undefined,
      edicaoCaraterSolicitacao: false,

      edicaoParecer: false,
      txtParecer: '',
      txtParecerButton: '',
      anchorElVertMenu: null,
      openCarencias: false,
    };
  }

  elementoApi = new ElementoApi();
  guiaApi = new GuiaApi();
  carenciaApi = new CarenciaApi();
  utils = new Utils();
  guiaApi = new GuiaApi();
  tipoDeAtendimentoApi = new TipoAtendimentoApi();
  beneficiarioApi = new BeneficiarioApi();


  componentDidMount = async () => {
    if (this.props.guia !== undefined) {
      const guiaSelecionada = this.props.guia;

      this.setState({
        guia: guiaSelecionada,
        txtParecer: guiaSelecionada.txtParecer === null ? '' : guiaSelecionada.txtParecer,
        elementos: guiaSelecionada.elementos,
        isElementosCarregado: true,
      });
    }
  }

  handleCloseDialogOperacao = () => {
    this.setState({ operacao: { dialog: { open: false } } });
  }

  todasAsGuiasEstaoNaoAnalisadas = () => {
    let todasAsGuiasEstaoNaoAnalisadas = true;
    this.state.guias.map(guiaDoLote => {
      if (guiaDoLote.codEstadoGuia !== 1) {
        todasAsGuiasEstaoNaoAnalisadas = false;
      }
    });
    return todasAsGuiasEstaoNaoAnalisadas;
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }


  handleCarenciasOpen = () => {
    this.setState({ openCarencias: true });
  }

  handleCloseCarencia = () => {
    this.setState({ openCarencias: false });
  }

  handleOpenVertMenu = event => {
    this.setState({ anchorElVertMenu: event.currentTarget });
  }

  handleCloseVertMenu = () => {
    this.setState({ anchorElVertMenu: null });
  }

  handleCloseGuiasSolicitacao = () => {
    this.setState({ guiasSolicitacao: {}, guiasSolicitacaoOpen: false });
  }

  handleClickOperacao = (id, dialogTitle, dialogMessage) => {
    const operacao = {
      clickedButton: id,
      dialog: {
        open: true,
        title: dialogTitle,
        message: dialogMessage
      }
    };
    this.setState({
      operacao: operacao,
    });
    this.handleCloseVertMenu();
  }

  conselhoProfissional = (input) => {
    if (input !== undefined && input !== null) {
      var inicio = input.indexOf('(');
      var fim = input.indexOf(')');
      if (inicio && fim) {
        return input.substring(inicio + 1, fim);
      } else {
        return input;
      }
    }
  }

  render() {
    const { classes, emAuditoria, guia } = this.props;
    const { isElementosCarregado } = this.state;

    console.log(guia);
    console.log(this.state.elementos);

    return (
      guia !== undefined ?
        <React.Fragment>
          <div className={classes.guiaContainer}>
              <div className={classes.root}>
                <Accordion style={{flexGrow: 1}} defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                  >
                    <Grid container direction="row" justifyContent='space-between' alignItems='center'>
                      <Grid item>
                        <Typography variant='h6'>
                          {guia.nomeBeneficiario} • {guia.numCarteiraTst}
                          <Typography inline fontStyle='italic' variant='caption'>{'  ' + format(guia.dtaRecebimento, 'DD/MM/YYYY')}</Typography>
                        </Typography>
                      </Grid>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid
                      container
                      direction='row'
                      spacing={4}
                      justifyContent='flex-start'
                      alignItems='flex-start'>
                      {guia.numGuiaPrestador || guia.numGuiaOperadora || guia.txtSenhaAutorizacao ?
                        <Grid item >
                          <Typography className={classes.label}>Nº Guia Prestador</Typography>
                          <Typography variant='button' title='Número da Guia do Prestador'>{guia.numGuiaPrestador}</Typography>
                          <Typography className={classes.label}>Nº Guia Operadora</Typography>
                          <Typography variant='button' title='Número da Guia da Operadora'>{guia.numGuiaOperadora}</Typography>
                          {guia.txtSenhaAutorizacao &&
                            <>
                              <Typography className={classes.label}>Senha: </Typography>
                              <Typography variant='button' title='Senha de Autorização'>{guia.txtSenhaAutorizacao}</Typography>
                            </>
                          }
                          {guia.txtParecer ?
                            <>
                              <Typography className={classes.label}>Parecer da auditoria: </Typography>
                              <Typography className={classes.labelDetalheParecer} title='Parecer da auditoria'>{guia.txtParecer}</Typography>
                            </>
                          : null}
                        </Grid> : null}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </div>
            {isElementosCarregado && this.state.elementos !== undefined
              ? <PainelElementos
                elementos={this.state.elementos}
                onOperacaoRealizada={null}
                emAuditoria={emAuditoria}
                readOnly={true}
                isGuiaSolicitacao={false} />
              : <LinearProgress />
            }
          </div>

        </React.Fragment>
        : <LinearProgressBlockScreen />
    );
  }
}
export default withAuditoria(withSnackbar(withLoading(withStyles(styles)(Guia))));
